module.exports = __webpack_public_path__ + "media/img/logos/2024/jobboerse-stellenangebote-berufseinsteiger-schnurrbart-8869607d1d9de4ad1644c95c68fd8891.svg";